import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgCar = ({ size = "regular", className = "", ...props }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M6.497 6.627C7.134 5.516 8.112 4 10.04 4h3.92c.942 0 1.639.345 2.177.885.492.493.844 1.145 1.152 1.718l.01.017.009.018.903 1.787a.75.75 0 0 1-.092.818h2.287c.384 0 .763.123 1.064.361l.014.012c.305.254.516.628.516 1.062v4.545c0 .434-.206.816-.53 1.073-.301.238-.68.361-1.064.361h-.813a3.203 3.203 0 0 1-6.228 0h-2.73a3.203 3.203 0 0 1-6.226.007h-.815c-.384 0-.763-.123-1.064-.361l-.014-.012A1.38 1.38 0 0 1 2 15.229v-4.545c0-.434.206-.816.53-1.073.301-.238.68-.361 1.064-.361H4.89zm-2.09 8.537a3.203 3.203 0 0 1 6.228-.007h2.73a3.203 3.203 0 0 1 6.228 0h.813a.3.3 0 0 0 .094-.016v-4.382a.3.3 0 0 0-.094-.016H7.521a.75.75 0 0 1 0-1.5h4.19a.75.75 0 0 1-.461-.692V5.5h-1.21c-.99 0-1.582.721-2.247 1.882l-.011.02-1.791 2.924a.75.75 0 0 1-.676.424H3.594a.3.3 0 0 0-.094.016v4.382a.3.3 0 0 0 .094.016zm4.816.724a1.702 1.702 0 1 0-3.403.038 1.702 1.702 0 0 0 3.403-.038m8.958.02v-.016a1.702 1.702 0 1 0 0 .03zm-1.216-6.665H12.29a.75.75 0 0 0 .46-.692V5.5h1.21c.52 0 .84.17 1.115.444.313.314.567.764.899 1.38l.899 1.778a.8.8 0 0 0 .092.141"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgCar;
